export function normalizeAssigneeKey(name) {
	return String(name || "")
		.trim()
		.replace(/\s+/g, " ")
		.toLowerCase();
}

export function canonicalizeAssigneeDisplay(name) {
	return String(name || "")
		.trim()
		.replace(/\s+/g, " ");
}

export function matchAssigneeSuggestion(suggestions, typedName) {
	const normalized = normalizeAssigneeKey(typedName);
	if (!normalized || !Array.isArray(suggestions)) return null;
	return suggestions.find((entry) => normalizeAssigneeKey(entry?.name || entry) === normalized) || null;
}

export function resolveAssigneeValue(suggestions, typedName) {
	const match = matchAssigneeSuggestion(suggestions, typedName);
	if (match) return canonicalizeAssigneeDisplay(match.name || match);
	return canonicalizeAssigneeDisplay(typedName);
}

export function suggestionOptions(suggestions) {
	if (!Array.isArray(suggestions)) return [];
	return suggestions
		.map((entry) => {
			const name = canonicalizeAssigneeDisplay(entry?.name || entry);
			if (!name) return null;
			return {
				label: name,
				value: name,
				normalizedName: entry?.normalizedName || normalizeAssigneeKey(name),
			};
		})
		.filter(Boolean);
}
